<script>
import { postData } from "./util/postData";
import { getData } from "./util/getData";
import { onMount } from "svelte";
import { fade } from 'svelte/transition';
import Home from "./Home.svelte";
import Receive from "./Receive.svelte";
import Submit from "./Submit.svelte";
import Header from "./layout/Header.svelte";
import Login from "./Login.svelte";

const validPages = ['home', 'receive', 'submit'];

//
// application state
//

/** the current application page. Stored in the query string **/
let currentPage = '';

/** The record id of the group for which this application is being accessed **/
let groupId = null;

/** The name of the group for which this application is being accessed **/
let groupName = "";

/** Whether or not an error has occurred on login. Used to trigger view changes in login component **/
let isLoginError = false;

/** The request id used to avoid a situation where the user who submitted a lament receives it **/
let requestId = '';

// aplication state initializers 
setTimeout(() => currentPage === '' ? currentPage = 'home' : void 0);
setTimeout(() => groupId === null ? groupId = '' : void 0);


//
// Component methods
// 

function navigateToPage(page) {
	window.history.pushState({}, 'Laments', `?page=${page}&gid=${groupId}`);
	currentPage = page;
}

async function validateGroup(gid) {
	if (!gid) {
		return false;
	}
	if (gid === groupId) {
		return true;
	}
	const response = await getData('validate-group', { code: gid });
	if (response && response.name) {
		// setTimeout hack to make sure name assignment makes it to home component
		setTimeout(() => groupName = response.name);
	}
	return !!response
}

async function createLament(lament) {
	await postData('create-lament', { code: groupId, lament, requestId });
}

async function claimLament(lamentId) {
	await postData('claim-lament', { code: groupId, lamentId, requestId });
}

async function handleBrowserNavigation() {
	const urlParams = new URLSearchParams(window.location.search);
	const page = urlParams.get('page');
	const gid = urlParams.get('gid');
	const isValidGroup = await validateGroup(gid);
	if (isValidGroup) {
		groupId = gid;
	}
	if (validPages.indexOf(page) >= 0) {
		currentPage = page;
	}
}

function generateRequestId() {
	return Math.floor(Math.random() * 1000000000000) + 1;
}

//
// Lifecycle methods
//

onMount(async () => {
	const storedRequestId = localStorage.getItem('reqid');
	if (storedRequestId) {
		requestId = storedRequestId;
	} else {
		requestId = generateRequestId();
		localStorage.setItem('reqid', requestId);
	}
	await handleBrowserNavigation()
})

//
// Event handlers
//

function onPopstate(event) {
	handleBrowserNavigation();
}

function onNavigate({ detail }) {
	if (currentPage !== detail) {
		navigateToPage(detail);
	}
}

async function onLamentSubmission({ detail: lament }) {
	await createLament(lament);
}

async function onLamantClaim({ detail: lamentId }) {
	await claimLament(lamentId);
}

async function onGroupValidate({ detail: gid }) {
	const isValid = await validateGroup(gid);
	if (isValid) {
		groupId = gid;
		// call navigateToPage in order to update query string
		navigateToPage(currentPage);
	} else {
		isLoginError = true;
	}
}

// transition configuration
const inDuration = 250;
const inDelay = 500;
const outDuration = 250;

</script>

<svelte:window on:popstate="{onPopstate}" />

<Header
	{groupId}
	{currentPage}
	on:navigate="{onNavigate}"
/>
<main>
	<div class="splash-container">
		<div class="splash">
		{#if groupId === ''}
			<div 
				in:fade="{{ delay: inDelay, duration: inDuration }}"
				out:fade="{{ duration: outDuration }}"
			>
				<Login 
					{isLoginError}
					on:submit="{onGroupValidate}"
				/>
			</div>
		{:else if currentPage === 'receive'}
			<div
				in:fade="{{ delay: inDelay, duration: inDuration }}"
				out:fade="{{ duration: outDuration }}"
			>
				<Receive 
					{groupId}
					{requestId}
					on:claim="{onLamantClaim}"
					on:navigate="{onNavigate}"
				/>
			</div>
		{:else if currentPage === 'submit'}
			<div
				in:fade="{{ delay: inDelay, duration: inDuration }}"
				out:fade="{{ duration: outDuration }}"
			>
				<Submit 
					on:submit="{onLamentSubmission}"
					on:navigate="{onNavigate}"
				/>
			</div>
		{:else if currentPage === 'home'}
			<div
				in:fade="{{ delay: inDelay, duration: inDuration }}"
				out:fade="{{ duration: outDuration }}"
			>
				<Home
					bind:groupName="{groupName}"
					on:navigate="{onNavigate}"
				/>
			</div>
		{/if}
		</div>
	</div>
</main>
